import { Popper } from '@mui/material';
import PopperJs from 'popper.js';
import React, { useRef } from 'react';
import { ActionsProps } from '../../FBApprovalMatrixRoles/components/Actions';
import Actions from './Actions';

interface Props extends ActionsProps {
  rootClassName?: string
  popperRef?: React.RefObject<PopperJs>
}

export const ActionsCell: React.FC<Props> = ({ popperRef, ...props }) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <>
      <div ref={ref} className={props.rootClassName} />
      {ref.current && (
        <Popper
          open
          placement="bottom-end"
          anchorEl={ref.current}
        >
          <Actions
            scrollBehavior="smooth"
            {...props} />
        </Popper>
      )}
    </>
  );
};
